import { render, staticRenderFns } from "./bonusCenter.vue?vue&type=template&id=73140b2a&"
import script from "./bonusCenter.vue?vue&type=script&lang=js&"
export * from "./bonusCenter.vue?vue&type=script&lang=js&"
import style0 from "./bonusCenter.vue?vue&type=style&index=0&id=73140b2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports